/**
 * @function allPropsAreEqual
 * @description
 * performs a shallow comparison between prev props and next props
 * and also compares date objects while ignoring millisecond discrepencies
 */
export const allPropsAreEqual = (options = {}) => (prevProps, nextProps) => {
  const prevValues = Object.values(prevProps);
  const nextValues = Object.values(nextProps);
  const propsDiffList = prevValues.filter((v, i) => {
    if (v instanceof Date && nextValues[i] instanceof Date) {
      return v.setMilliseconds(0) - nextValues[i].setMilliseconds(0) !== 0;
    }
    // optionally freeze functions by setting memoizeFns option to true
    // return false if the function will never change
    if (
      options.memoizeFns &&
      typeof v === 'function' &&
      typeof nextValues[i] === 'function'
    ) {
      return false;
    }
    return v !== nextValues[i];
  });
  return propsDiffList.length === 0;
};
